<template>
    <button
        class="flex items-center justify-center rounded-lg | transition duration-200 | focus:outline-none"
        :class="[
            sizeClass,
            colorClass,
            {
                'focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500':
                    !isDisabled,
            },
        ]"
        :disabled="isDisabled"
        :tabindex="tabIndex"
        type="button"
        @click="emit('click')"
        v-text="label"
    />
</template>

<script setup lang="ts">
    import { computed } from 'vue';

    interface Props {
        label: string;
        isActive?: boolean;
        isDisabled?: boolean;
        tabIndex?: number | string;
        size?: 'md' | 'sm';
        variant?: 'neutral' | 'primary';
    }

    const props = withDefaults(defineProps<Props>(), {
        isActive: false,
        isDisabled: false,
        size: 'md',
        variant: 'neutral',
    });

    const emit = defineEmits<(e: 'click') => void>();

    const sizeClass = computed(() => {
        if (props.size === 'sm') {
            return 'px-2.5 py-1 text-[13px] whitespace-nowrap';
        }
        return 'h-10 py-1.5 px-3 min-w-20';
    });

    const colorClass = computed(() => {
        if (props.isDisabled) {
            return 'cursor-not-allowed text-gray-500';
        }

        if (props.isActive) {
            if (props.variant === 'primary') {
                return 'bg-blue-500 text-white';
            }
            return 'bg-gray-250 text-gray-800';
        }

        return 'text-gray-700 hover:bg-gray-150 hover:text-gray-750';
    });
</script>
